import React, { Component } from "react";
import { connect } from "react-redux";
import LayoutWrap from "../Component/LayoutWrap";
import MainButton from "../Component/UI/MainButton";
import { HiOutlineArrowRight } from "react-icons/hi";
import { dashboardActions } from "../../../_actions";
import { dashboard } from "../../../_reducers/dashboard.reducer";

/* Constants */
const HERO_IMAGE =
  "https://d2xsxph8kpxj0f.cloudfront.net/310519663381845173/eiyGwvWkXuNpnLBHsmiF6r/abg-hero-team-38Kga4xXNLLaHo4po8ULc7.webp";

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    this.props.dispatch(dashboardActions.getConnectDetails({}));
  }

  goToPage = () => {
    this.props.history.push("/insight/dashboard");
  }

  render() {
    let { dashboard } = this.props;
    let { getConnectDetailsData: data } = dashboard;


    const content = {
      title: data?.title || "",
      desc: data?.desc || "",
      contactDesc: data?.contactDesc || "",
      person: data?.person || "",
      designation: data?.designation || "",
      email: data?.email || "",
      mobile: data?.mobile || "",
      logo: data?.logo || ""
    };
    console.log("logo---x3---->", content.logo)

    return (
      <LayoutWrap logo={content.logo}>
        <div className="md:p-6 p-4">
          <div className="bg-white w-full flex overflow-hidden">

            {/* LEFT IMAGE */}
            <div className="w-[30%] hidden md:block">
              <img src={HERO_IMAGE} alt="office" className="h-full w-full object-cover rounded-l-3xl" />
            </div>

            {/* RIGHT CONTENT */}
            <div className="w-full md:w-[70%] pt-6 pl-6 pr-6 md:pt-6 md:pl-10 md:pr-10 flex flex-col justify-between">

              <div>
                <div className="space-y-6 mb-8">
                  <h1 className="md:text-3xl text-2xl y-4 mb-8 font-semibold textblack">{content.title}</h1>
                  <p className="font-semibold textblack text-xl pt-2">Dear Participant,</p>
                  {/* <p className="textblack text-lg">Welcome to Insight Plus,</p> */}
                  <p
                    className="textblack text-base leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: content.desc || "" }}
                  />
                </div>

                {/* INFO CARD */}
                <div className="bg-gray-100 border-l-4 border-indigo-600 rounded-xl p-6 mb-8">
                  <p className="textblack italic mb-6 md:text-base text-sm"> {content.contactDesc}</p>

                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
                    <div>
                      <p className="text-base font-semibold textblack mb-1">{content.designation}</p>
                      <p className="textblack text-sm">{content.person}</p>
                    </div>
                    <div className="sm:border-l sm:border-r border-gray-300">
                      <p className="md:text-base text-sm font-semibold textblack mb-1">Email Id</p>
                      <p className="textblack text-sm">{content.email}</p>
                    </div>
                    <div>
                      <p className="md:text-base text-sm font-semibold textblack mb-1">Contact No.</p>
                      <p className="textblack text-sm">{content.mobile}</p>
                    </div>
                  </div>
                </div>

                {/* BUTTON */}
                <MainButton title="NEXT" Icon={HiOutlineArrowRight} onClick={() => this.goToPage()} />
              </div>

              {/* FOOTER */}
              <p className="text-sm textblack mt-8 text-center md:text-left">© 2026 InsightPlus. All rights reserved.</p>
            </div>
          </div>
        </div>
      </LayoutWrap>
    );
  }
}

const mapStateToProps = (state) => ({
  loggingIn: state.authentication?.loggingIn,
  dashboard: state.dashboard,
  user: state.user,
  panel: state.panel,
});

export default connect(mapStateToProps)(Overview);